import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import WallOfFame from "../components/achievements";
import Addreference from "../components/addreference";
import Certification from "../components/certifications";
import Projects from "../components/projects";
import Contact from "../components/Contact";
import Positionrespons from "../components/positionrespons";
import HeroSection from "../components/Herosection";

const Home = () => {
  return (
    <div>
      <section id="home">
        <HeroSection />
      </section>
      <section id="achievements">
        <WallOfFame />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="events">
        <Certification />
      </section>
      <section id="positionrespons">
        <Positionrespons />
      </section>
      <section id="recommend">
        <Addreference />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
};

export default Home;
